$ = jQuery = require( 'jquery' );

$(function(){
  // ===== 流入元パラメータ保存/取得（utm_source等を sessionStorage で保持）=====
  var trackingKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'inflow'];
  (function saveTrackingParams() {
    var search = new URLSearchParams(window.location.search);
    trackingKeys.forEach(function(key) {
      var val = search.get(key);
      if (val) {
        try { sessionStorage.setItem('storelp_' + key, val); } catch (e) {}
      }
    });
  })();
  var getTrackingParams = function() {
    var result = {};
    trackingKeys.forEach(function(key) {
      try { result[key] = sessionStorage.getItem('storelp_' + key) || ''; } catch (e) { result[key] = ''; }
    });
    return result;
  };

  var header = document.querySelector('.store-lp-header');
  var fv = document.querySelector('.fv-section');
  if (header && fv) {
    var onHeaderScroll = function() {
      if (window.scrollY > fv.offsetHeight - header.offsetHeight) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    };
    window.addEventListener('scroll', onHeaderScroll, { passive: true });
    onHeaderScroll();
  }

  // 追従CTA（スマホのみ）は FV を通過してから、フッターに到達するまで表示する
  var stickyCta = document.querySelector('.sticky-cta');
  var lpFooter = document.querySelector('.store-lp-footer');
  if (stickyCta && fv) {
    var onStickyCtaScroll = function() {
      // FV の下端が画面上部まで来たら表示する（FV を見終わるタイミングで出す）
      var passedFv = fv.getBoundingClientRect().bottom <= window.innerHeight * 0.3;
      var reachedFooter = lpFooter && lpFooter.getBoundingClientRect().top <= window.innerHeight;
      if (passedFv && !reachedFooter) {
        stickyCta.classList.add('is-visible');
      } else {
        stickyCta.classList.remove('is-visible');
      }
    };
    window.addEventListener('scroll', onStickyCtaScroll, { passive: true });
    window.addEventListener('resize', onStickyCtaScroll, { passive: true });
    onStickyCtaScroll();
  }

  var stepSection = document.querySelector('.step-section');
  if (header && stepSection) {
    var onStepScroll = function() {
      var rect = stepSection.getBoundingClientRect();
      var headerBottom = header.getBoundingClientRect().bottom;
      if (rect.top <= headerBottom && rect.bottom >= headerBottom) {
        header.classList.add('is-on-step');
      } else {
        header.classList.remove('is-on-step');
      }
    };
    window.addEventListener('scroll', onStepScroll, { passive: true });
    onStepScroll();
  }

  var scrollEl = document.querySelector('.comparison-section__scroll');
  var track = document.querySelector('.comparison-section__scrollbar-track');
  var thumb = document.querySelector('.comparison-section__scrollbar-thumb');

  if (scrollEl && track && thumb) {
    var updateThumb = function() {
      var scrollW = scrollEl.scrollWidth;
      var clientW = scrollEl.clientWidth;
      var trackW = track.clientWidth;

      if (scrollW <= clientW + 1) {
        thumb.style.width = trackW + 'px';
        thumb.style.transform = 'translateX(0)';
        return;
      }

      var thumbW = Math.max((clientW / scrollW) * trackW, 40);
      var pos = (scrollEl.scrollLeft / (scrollW - clientW)) * (trackW - thumbW);
      thumb.style.width = thumbW + 'px';
      thumb.style.transform = 'translateX(' + pos + 'px)';
    };

    scrollEl.addEventListener('scroll', updateThumb);
    window.addEventListener('resize', updateThumb);
    window.addEventListener('load', updateThumb);
    updateThumb();

    var maxScroll = function() {
      return scrollEl.scrollWidth - scrollEl.clientWidth;
    };
    var maxThumb = function() {
      return track.clientWidth - thumb.offsetWidth;
    };

    var dragging = false;
    var startX = 0;
    var startScroll = 0;

    thumb.addEventListener('pointerdown', function(e) {
      dragging = true;
      startX = e.clientX;
      startScroll = scrollEl.scrollLeft;
      thumb.setPointerCapture(e.pointerId);
      e.preventDefault();
    });

    thumb.addEventListener('pointermove', function(e) {
      if (!dragging) return;
      var mt = maxThumb();
      if (mt <= 0) return;
      scrollEl.scrollLeft = startScroll + ((e.clientX - startX) / mt) * maxScroll();
    });

    var endDrag = function(e) {
      if (!dragging) return;
      dragging = false;
      if (e.pointerId != null && thumb.hasPointerCapture(e.pointerId)) {
        thumb.releasePointerCapture(e.pointerId);
      }
    };
    thumb.addEventListener('pointerup', endDrag);
    thumb.addEventListener('pointercancel', endDrag);

    track.addEventListener('pointerdown', function(e) {
      if (e.target === thumb) return;
      var rect = track.getBoundingClientRect();
      var ratio = (e.clientX - rect.left - thumb.offsetWidth / 2) / maxThumb();
      scrollEl.scrollLeft = Math.min(Math.max(ratio, 0), 1) * maxScroll();
    });
  }

  var caseModals = document.querySelectorAll('.case-modal');
  if (caseModals.length) {
    var openCaseModal = function(modal) {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('case-modal-open');
    };
    var closeCaseModal = function(modal) {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('case-modal-open');
    };

    document.querySelectorAll('[data-case-modal]').forEach(function(trigger) {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        var modal = document.getElementById('case-modal-' + trigger.getAttribute('data-case-modal'));
        if (modal) openCaseModal(modal);
      });
    });

    caseModals.forEach(function(modal) {
      modal.querySelectorAll('[data-case-modal-close]').forEach(function(el) {
        el.addEventListener('click', function() { closeCaseModal(modal); });
      });
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        caseModals.forEach(closeCaseModal);
      }
    });
  }

  document.querySelectorAll('.faq-item').forEach(function(item) {
    var q = item.querySelector('.faq-item__q');
    if (!q) return;
    q.addEventListener('click', function() {
      item.classList.toggle('is-open');
    });
  });

  var caseCards = document.querySelector('.case-section__cards');
  var caseDots = document.querySelectorAll('.case-section__dot');
  if (caseCards && caseDots.length) {
    caseCards.addEventListener('scroll', function() {
      var idx = Math.round(caseCards.scrollLeft / caseCards.clientWidth);
      caseDots.forEach(function(dot, i) {
        dot.classList.toggle('is-active', i === idx);
      });
    }, { passive: true });

    caseDots.forEach(function(dot, i) {
      dot.addEventListener('click', function() {
        caseCards.scrollTo({ left: caseCards.clientWidth * i, behavior: 'smooth' });
      });
    });
  }

  // ===== 資料ダウンロード モーダル =====
  var dlModal = document.querySelector('.dl-modal');
  if (dlModal) {
    var dlBody = dlModal.querySelector('[data-dl-modal-body]');
    var dlSuccess = dlModal.querySelector('[data-dl-modal-success]');
    var dlForm = dlModal.querySelector('[data-dl-modal-form]');
    var dlError = dlModal.querySelector('[data-dl-modal-error]');
    var dlSubmit = dlForm ? dlForm.querySelector('button[type="submit"]') : null;
    var dlSubmitLabel = dlSubmit ? dlSubmit.querySelector('.dl-modal__submit-label') : null;
    var dlSubmitBadge = dlSubmit ? dlSubmit.querySelector('.dl-modal__submit-badge') : null;
    var dlSubmitDefaultText = dlSubmitLabel ? dlSubmitLabel.textContent : '';
    var dlLoading = document.querySelector('[data-dl-loading]');
    var isSubmitting = false;
    var mediumUuid = dlModal.getAttribute('data-medium-uuid');

    var showDlLoading = function() {
      if (dlLoading) {
        dlLoading.style.display = 'block';
        dlLoading.setAttribute('aria-hidden', 'false');
      }
    };
    var hideDlLoading = function() {
      if (dlLoading) {
        dlLoading.style.display = 'none';
        dlLoading.setAttribute('aria-hidden', 'true');
      }
    };

    var apiBase = (function() {
      var hostname = window.location.hostname;
      if (hostname === 'localhost' || hostname.indexOf('localhost') !== -1) {
        return 'http://api-est.localhost:5000';
      }
      var root = hostname.replace(/^www\./, '');
      return 'https://api-est.' + root;
    })();

    var resetDlModal = function() {
      if (dlForm) dlForm.reset();
      if (dlError) {
        dlError.hidden = true;
        dlError.textContent = '';
      }
      if (dlBody) dlBody.hidden = false;
      if (dlSuccess) dlSuccess.hidden = true;
      if (dlSubmit) dlSubmit.disabled = false;
    };

    var openDlModal = function() {
      resetDlModal();
      dlModal.classList.add('is-open');
      dlModal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('dl-modal-open');
    };

    var closeDlModal = function() {
      if (isSubmitting) return;
      dlModal.classList.remove('is-open');
      dlModal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('dl-modal-open');
    };

    document.querySelectorAll('[data-download-modal]').forEach(function(trigger) {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        openDlModal();
      });
    });

    dlModal.querySelectorAll('[data-dl-modal-close]').forEach(function(el) {
      el.addEventListener('click', function(e) {
        e.preventDefault();
        closeDlModal();
      });
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && dlModal.classList.contains('is-open')) {
        closeDlModal();
      }
    });

    if (dlForm) {
      dlForm.addEventListener('submit', function(e) {
        e.preventDefault();
        if (!dlForm.reportValidity()) return;
        isSubmitting = true;
        showDlLoading();
        if (dlSubmit) {
          dlSubmit.disabled = true;
          dlSubmit.classList.add('is-loading');
        }
        if (dlSubmitLabel) dlSubmitLabel.textContent = '送信中...';
        if (dlSubmitBadge) dlSubmitBadge.hidden = true;
        if (dlError) {
          dlError.hidden = true;
          dlError.textContent = '';
        }

        var data = new FormData(dlForm);
        var tracking = getTrackingParams();
        var payload = {
          medium_uuid: mediumUuid,
          company_name: (data.get('company_name') || '').trim(),
          email: (data.get('email') || '').trim(),
          tel: (data.get('tel') || '').trim(),
          utm_source: tracking.utm_source,
          utm_medium: tracking.utm_medium,
          utm_campaign: tracking.utm_campaign,
          inflow: tracking.inflow
        };

        var params = new URLSearchParams();
        for (var k in payload) params.append(k, payload[k]);

        fetch(apiBase + '/v1/mdl', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: params.toString()
        }).then(function(res) {
          return res.json().then(function(body) {
            return { status: res.status, body: body };
          });
        }).then(function(result) {
          if (result.status === 200) {
            window.location.href = '/store_lp/document_thanks';
            return;
          } else {
            var errs = result.body && result.body.errors;
            var msg = Array.isArray(errs) ? errs.join(' / ') : (typeof errs === 'string' ? errs : '送信に失敗しました。入力内容をご確認の上、再度お試しください。');
            if (dlError) {
              dlError.textContent = msg;
              dlError.hidden = false;
            }
          }
        }).catch(function() {
          if (dlError) {
            dlError.textContent = '通信エラーが発生しました。しばらく時間をおいて再度お試しください。';
            dlError.hidden = false;
          }
        }).finally(function() {
          isSubmitting = false;
          hideDlLoading();
          if (dlSubmit) {
            dlSubmit.disabled = false;
            dlSubmit.classList.remove('is-loading');
          }
          if (dlSubmitLabel) dlSubmitLabel.textContent = dlSubmitDefaultText;
          if (dlSubmitBadge) dlSubmitBadge.hidden = false;
        });
      });
    }
  }

  // ===== サンクスページ: トライアルバナーのスクロールフェードイン =====
  var thanksTrialBanner = document.querySelector('[data-thanks-trial-banner]');
  if (thanksTrialBanner) {
    var trialShowThreshold = 200;
    var updateTrialBanner = function() {
      if (window.pageYOffset > trialShowThreshold) {
        thanksTrialBanner.classList.add('is-visible');
      } else {
        thanksTrialBanner.classList.remove('is-visible');
      }
    };

    var trialCloseBtn = thanksTrialBanner.querySelector('[data-thanks-trial-close]');
    if (trialCloseBtn) {
      trialCloseBtn.addEventListener('click', function() {
        thanksTrialBanner.classList.add('is-hidden');
      });
    }

    window.addEventListener('scroll', updateTrialBanner, { passive: true });
    updateTrialBanner();
  }

  // ===== トライアルページ: 資料DLバナーのスクロールフェードイン =====
  var trialDlBanner = document.querySelector('[data-trial-dl-banner]');
  if (trialDlBanner) {
    var dlBannerThreshold = 200;
    var updateDlBanner = function() {
      if (window.pageYOffset > dlBannerThreshold) {
        trialDlBanner.classList.add('is-visible');
      } else {
        trialDlBanner.classList.remove('is-visible');
      }
    };

    var dlBannerCloseBtn = trialDlBanner.querySelector('[data-trial-dl-close]');
    if (dlBannerCloseBtn) {
      dlBannerCloseBtn.addEventListener('click', function() {
        trialDlBanner.classList.add('is-hidden');
      });
    }

    window.addEventListener('scroll', updateDlBanner, { passive: true });
    updateDlBanner();
  }

  // ===== 無料トライアル申込フォーム =====
  var trialForm = document.querySelector('[data-trial-form]');
  if (trialForm) {
    var trialSubmit = trialForm.querySelector('button[type="submit"]');
    var trialMediumUuid = trialForm.getAttribute('data-medium-uuid');

    var trialApiBase = (function() {
      var hostname = window.location.hostname;
      if (hostname === 'localhost' || hostname.indexOf('localhost') !== -1) {
        return 'http://api-est.localhost:5000';
      }
      var root = hostname.replace(/^www\./, '');
      return 'https://api-est.' + root;
    })();

    var trialSubmitLabel = trialSubmit ? trialSubmit.querySelector('.trial-form__submit-label') : null;
    var trialSubmitDefaultText = trialSubmitLabel ? trialSubmitLabel.textContent : '';
    var trialLoading = document.querySelector('[data-dl-loading]');
    var showTrialLoading = function() {
      if (trialLoading) {
        trialLoading.style.display = 'block';
        trialLoading.setAttribute('aria-hidden', 'false');
      }
    };
    var hideTrialLoading = function() {
      if (trialLoading) {
        trialLoading.style.display = 'none';
        trialLoading.setAttribute('aria-hidden', 'true');
      }
    };

    trialForm.addEventListener('submit', function(e) {
      e.preventDefault();
      if (!trialForm.reportValidity()) return;
      showTrialLoading();
      if (trialSubmit) trialSubmit.disabled = true;
      if (trialSubmitLabel) trialSubmitLabel.textContent = '送信中...';

      var data = new FormData(trialForm);
      var tracking = getTrackingParams();
      var payload = {
        medium_uuid: trialMediumUuid,
        company_name: (data.get('company_name') || '').trim(),
        email: (data.get('email') || '').trim(),
        tel: (data.get('tel') || '').trim(),
        utm_source: tracking.utm_source,
        utm_medium: tracking.utm_medium,
        utm_campaign: tracking.utm_campaign,
        inflow: tracking.inflow
      };

      var params = new URLSearchParams();
      for (var k in payload) params.append(k, payload[k]);

      fetch(trialApiBase + '/v1/ftl', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString()
      }).then(function(res) {
        return res.json().then(function(body) {
          return { status: res.status, body: body };
        });
      }).then(function(result) {
        if (result.status === 200) {
          window.location.href = '/store_lp/trial_thanks';
          return;
        }
        var errs = result.body && result.body.errors;
        var msg = Array.isArray(errs) ? errs.join(' / ') : (typeof errs === 'string' ? errs : '送信に失敗しました。入力内容をご確認の上、再度お試しください。');
        alert(msg);
      }).catch(function() {
        alert('通信エラーが発生しました。しばらく時間をおいて再度お試しください。');
      }).finally(function() {
        hideTrialLoading();
        if (trialSubmit) trialSubmit.disabled = false;
        if (trialSubmitLabel) trialSubmitLabel.textContent = trialSubmitDefaultText;
      });
    });
  }
});



//////////////////
// WEBPACK FOOTER
// ./app/assets/javascripts/store_lp.js
// module id = 0
// module chunks = 4